import { render, staticRenderFns } from "./helpButton.vue?vue&type=template&id=57cc0253&"
import script from "./helpButton.vue?vue&type=script&lang=js&"
export * from "./helpButton.vue?vue&type=script&lang=js&"
import style0 from "./helpButton.vue?vue&type=style&index=0&id=57cc0253&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cc0253')) {
      api.createRecord('57cc0253', component.options)
    } else {
      api.reload('57cc0253', component.options)
    }
    module.hot.accept("./helpButton.vue?vue&type=template&id=57cc0253&", function () {
      api.rerender('57cc0253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/helpButton.vue"
export default component.exports